import declare from "dojo/_base/declare";
import ActionViewConstructor, { ActionView } from "csi/action/ActionView";
import def from	"csi/def";
import reflection from "csi/reflection";
import AggregateFrom from "csi/table/AggregateFrom";
import { View } from "csi/def/View";

interface IDPDocumentsActionView {
	/** The count of items selected. */
	view: string;
	/** The function to clear all items in the selection. */
	isColorAllocatedView: boolean;
}

const SELECT_DOCS_BOM_ACTION = "SelectDocsFromBOMOnStyle";
const SELECT_DOCS_BOM_VIEW = "SelectDocsFromBOMOnStyleDP";
const SELECT_DOCS_BOM_COLOR_ALLOCATION_VIEW = "SelectDocsFromBOMOnStyleWithColorAllocationDP";
const SELECT_DOCS_MATERIAL_VIEW = "SelectDocumentsFromMaterialDP";
const SELECT_DOCS_MATERIAL_ACTION = "SelectDocsFromMaterial";
const SELECT_DOCS_BOM_MATERIAL_COLOR_ALLOCATION_VIEW = "SelectDocsFromBOMOnMaterialWithColorAllocationDP";
const SELECT_DOCS_BOM_MATERIAL_VIEW = "SelectDocsFromBOMOnMaterialDP";
const SELECT_DOCS_BOM_MATERIAL_ACTION = "SelectDocsFromBOMOnMaterial";
const SELECT_DOCS_COLOR_MATERIAL_ACTION = "SelectDocsFromColorsOnMaterial";
const SELECT_DOCS_COLOR_MATERIAL_VIEW = "SelectDocsFromColorsOnMaterialDP";
const SELECT_DOCS_COLOR_MATERIAL_COLOR_ALLOCATION_VIEW = "SelectDocsFromColorsOnMaterialWithColorAllocationDP";

const SELECT_DOCS_COLORS_ACTION = "SelectDocsFromColorsOnStyle";
const SELECT_DOCS_COLORS_VIEW = "SelectDocsFromColorsOnStyleDP";
const SELECT_DOCS_COLORS_COLOR_ALLOCATION_VIEW = "SelectDocsFromColorsOnStyleDPWithColorAllocationDP";
const SELECT_DOCS_MATERIAL_COLOR_ALLOCATION_VIEW = "SelectDocumentsFromMaterialWithColorAllocationDP";

const  viewSelectDocsFromBOM: IDPDocumentsActionView = { view: SELECT_DOCS_BOM_VIEW, isColorAllocatedView: false }; 
const  viewSelectDocsFromBOMWithColorAllocation: IDPDocumentsActionView = { view: SELECT_DOCS_BOM_COLOR_ALLOCATION_VIEW, isColorAllocatedView: true }; 
const  viewSelectDocsFromColorsOnStyleDP: IDPDocumentsActionView = { view: SELECT_DOCS_COLORS_VIEW, isColorAllocatedView: false }; 
const  viewSelectDocsFromColorsOnStyleDPWithColorAllocation: IDPDocumentsActionView = { view: SELECT_DOCS_COLORS_COLOR_ALLOCATION_VIEW, isColorAllocatedView: true }; 
const  viewSelectDocumentsFromMaterialWithColorAllocationDP: IDPDocumentsActionView = { view: SELECT_DOCS_MATERIAL_COLOR_ALLOCATION_VIEW, isColorAllocatedView: true }; 
const  viewSelectDocsFromMaterial: IDPDocumentsActionView ={ view: SELECT_DOCS_MATERIAL_VIEW, isColorAllocatedView: false };
const  viewSelectDocsFromBomOnMaterial: IDPDocumentsActionView = { view: SELECT_DOCS_BOM_MATERIAL_VIEW, isColorAllocatedView: false };
const  viewSelectDocsFromBomOnMaterialWithColorAllocation: IDPDocumentsActionView = { view: SELECT_DOCS_BOM_MATERIAL_COLOR_ALLOCATION_VIEW, isColorAllocatedView: true };
const  viewSelectDocsFromColorOnMaterial: IDPDocumentsActionView = { view: SELECT_DOCS_COLOR_MATERIAL_VIEW, isColorAllocatedView: false };
const  viewSelectDocsFromColorOnMaterialWithColorAllocation: IDPDocumentsActionView = { view: SELECT_DOCS_COLOR_MATERIAL_COLOR_ALLOCATION_VIEW, isColorAllocatedView: true };

const viewsMap: Map<string, IDPDocumentsActionView[]> = new Map([
	[SELECT_DOCS_BOM_ACTION, [viewSelectDocsFromBOM, viewSelectDocsFromBOMWithColorAllocation]],
	[SELECT_DOCS_COLORS_ACTION, [viewSelectDocsFromColorsOnStyleDP, viewSelectDocsFromColorsOnStyleDPWithColorAllocation]],
	[SELECT_DOCS_MATERIAL_ACTION, [viewSelectDocsFromMaterial, viewSelectDocumentsFromMaterialWithColorAllocationDP]],
	[SELECT_DOCS_BOM_MATERIAL_ACTION, [viewSelectDocsFromBomOnMaterial, viewSelectDocsFromBomOnMaterialWithColorAllocation]],
	[SELECT_DOCS_COLOR_MATERIAL_ACTION, [viewSelectDocsFromColorOnMaterial, viewSelectDocsFromColorOnMaterialWithColorAllocation]],
]);

const SelectViewDataPackageDocs = declare(AggregateFrom, {

	getActionView(/*ViewRef?*/vr): ActionView {
		const actionId = this.m_action.m_id;
		const rc = reflection.getClass("DataPackage");
		const ctx = this.getContext();
		const parent = ctx.getParent();
		const style = this.getCache()
			.getNode(this.getParent().__Parent__);
		const defView = this._defineViewToRender(actionId, rc, style);
		return new ActionViewConstructor(this, defView, parent);
	},

	_defineViewToRender(actionId, rc, style): View {
		let defView;
		const view = viewsMap.get(actionId);
		if (style.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP"){
			//we only have 1 view per case. the filter result are going to be always 1.
			const filteredView = view.filter((view) => view.isColorAllocatedView);
			defView = def.getClassViewDef(rc, filteredView[0].view);
		} else {
			const filteredView = view.filter((view) => !view.isColorAllocatedView);
			defView = def.getClassViewDef(rc, filteredView[0].view);
		}
		return defView;
	},
});

export = SelectViewDataPackageDocs;